import type { Space } from '@sravni/react-design-system';
import React from 'react';

import { useAppSelector } from 'shared/lib';
import { OfferCard, OfferDetailsCard, OfferPreviewCard } from 'shared/ui/OfferCard';

import { getOfferInfoData } from 'features/OfferCardContainer/model/offerCard.selector';

interface IOfferCardContainerProps {
  containerProps?: React.ComponentProps<typeof Space>;
  detailsProps?: React.ComponentProps<typeof Space>;
  type?: 'base' | 'preview' | 'details' | 'credit-card';
}

export const OfferCardContainer: React.FC<IOfferCardContainerProps> = ({
  children,
  containerProps = {},
  type = 'base',
  detailsProps = { justify: 'center', wrap: false },
}) => {
  const { organizationLogo, summaries, organizationName, productType, alias, amount, creditCardLogo } =
    useAppSelector(getOfferInfoData);

  switch (type) {
    case 'details':
      return (
        <OfferDetailsCard
          containerProps={containerProps}
          logo={creditCardLogo || organizationLogo}
          title={amount?.value}
          subtitle={alias}
          details={summaries}
          detailsProps={detailsProps}
        />
      );

    case 'preview':
      return (
        <OfferPreviewCard
          containerProps={containerProps}
          button={children}
          logo={creditCardLogo || organizationLogo}
          title={amount?.value}
          subtitle={alias}
          details={summaries}
          detailsProps={detailsProps}
        />
      );
    case 'credit-card':
      return (
        <OfferPreviewCard
          containerProps={containerProps}
          button={children}
          logo={creditCardLogo || organizationLogo}
          title={amount?.value}
          subtitle={alias}
          details={summaries}
          detailsProps={detailsProps}
        />
      );
    default:
      return (
        <OfferCard
          containerProps={containerProps}
          button={children}
          logo={creditCardLogo || organizationLogo}
          title={organizationName}
          subtitle={productType}
          details={summaries}
        />
      );
  }
};
